import type { TravellerV2Data, TravellerV2Payload } from "../TravellerDetailsV2.types";

export function unwrapTravellerPayload(payload: TravellerV2Payload): TravellerV2Data {
  if (
    payload &&
    typeof payload === "object" &&
    "data" in payload &&
    payload.data &&
    typeof payload.data === "object"
  ) {
    return payload.data as TravellerV2Data;
  }
  return payload as TravellerV2Data;
}
